module.exports = __webpack_public_path__ + "static/img/live_weixin_th.9ac0051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live_weixin_th.png
// module id = C1d4
// module chunks = 0